import { required, shape } from '@totalsoft/pure-validations';

export const engineAttributeValidator = shape({
  orderNo: required,
  attributeName: required,
  expression: required
});
